import React, { useEffect, useState,useCallback } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import Select from "react-select";
import Index from '../Assets/Images/delete.png';

const pageSize = 5;

const ParoassignMain = () => {

  /*----Display Paro users ----*/

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const [allusers,setAllusers]= useState([])
  const [allusers1,setAllusers1]= useState([])

//   const [paginatedPosts, setpaginatedPosts] = useState();
//  const [currentPage, setcurrentPage] = useState(1);

  useEffect(()=>{
    Getusers();
    GetAssignusers(); 
  },[])

  function Getusers(){
    console.log("Token",token)

    fetch(`${BASE_URL}/Paropakari/GetParoUsers`, {

      method:'GET',
      headers : {

        "Content-type": "application/json",

        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },

      //body:JSON.stringify(data)

    }).then(response => response.json())
    .then(data => {
      console.log("Data",data)
      setAllusers1(data)
      

    });
    console.log("check",allusers1)
  }



  /*----Display Corp users ----*/
    // const token = JSON.parse(localStorage.getItem('usertoken'));
    const [Assignusers,setAssignusers]= useState([])
    const [paginatedPosts, setpaginatedPosts] = useState();
    //const [currentPage, setcurrentPage] = useState(1);

    function GetAssignusers(){
    console.log("Token",token)
  
      fetch('https://localhost:44312/Api/Paropakari/GetParoAssignUser',{
 
        method:"GET",
        headers:{
          "Content-type": "application/json",
  
          "Accept": "application/json",
    
          "Authorization": "Bearer " + `${token}`,
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
           //body:JSON.stringify(data)
  
      }).then(response=> response.json())
      .then(data=>{
        console.log("Data",data)
        setAllusers(data)
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("Paro-assignusers", JSON.stringify(data));
      });
      console.log("check",allusers)
    }


    // const pageCount = allusers? Math.ceil(allusers.length/pageSize) : 0 ;
    // // if (pageCount === 1)
    // // return null;
    
    // const pages = _.range(1, pageCount+1)
    
    // const pagination =(pageNo)=>{
    // setcurrentPage(pageNo);
    // const startIndex = (pageNo-1) * pageSize;
    // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
    // setpaginatedPosts(paginatedPost)
    // }
  


  /*----Assign Fetch----*/

 // AssignSection

 const [selectedOptions, setSelectedOptions] = useState();
 const optionList = [
  { value: "Causes", label: "Causes" },
  { value: "Index", label: "Index" },
  { value: "Payment", label: "Payment" }
 
  
];

function handleSelect(data) {
  setSelectedOptions(data);
}





 function AssignSection(){


  //  let checkbox = document.getElementById('checkbox').value
  // var username = document.getElementById('username').value;
 
 
   var id = document.getElementById('Parouserid').value
 
   let assign = selectedOptions.map((item)=> item.label);
   console.log(assign)
   
   let section=assign.toString();
   
  
 
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  // console.log(section);
  
  const body ={
    id:id,  
    section:section,
    assignStatus:0
  }
  axios({

    method:"POST",
    url:`${BASE_URL}/Paropakari/ParoAssignSection`,
    data:body,
    headers: {
      "Content-Type" : "application/json",

      'Authorization':bearer 
    }

})
.then((response) =>{
  console.log(response.data);

alert("Assigned Successfully !")

  // toast.success("Task Assigned Successfully !", {
  //   position: "top-center",
  //   autoClose: 3200,
  //   hideProgressBar: false,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: true,
  //   progress: undefined,
  //   className: 'toast-message'
  //   });
    setTimeout(() => {
     
      Getusers();
      GetAssignusers();
      setSelectedOptions("");
    }, 1000);
   

 })
 .catch(error => {
 console.log(error);
alert("failed !")

  })
  }








//SelectParticular

const [EditParo, setEditParo] =useState([])

function SelectParticular(Id){

  const body =
    {
      
     id:Id
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/Paropakari/GetParoEditAddUsers`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + `${token}`,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
          setEditParo(response.data)
                
          localStorage.setItem("EditData",JSON.stringify(response.data))
          
       })
       .catch(error => {
        //  console.log(error);
         
       })
 }


 //  ConfirmDelete 


 function ConfirmDelete(Id,UserName)
 {

   
   SelectParticular(Id,UserName)

   setTimeout(() => {
     document.getElementById("modaldeleteForm").style.display = "block";
   },1000);
  
  } 



  function DeleteStatus(Id,UserName){
  
    //confirm delete

 
     const body ={
      id: Id
    }
     console.log(body)
      axios({
     
      method:"POST",
     url:`${BASE_URL}/Paropakari/ParoAssignDelete`,
     data:body,
     headers: {
     "Content-Type" : "application/json",

     "Authorization": "Bearer " + `${token}`,
  
     }
    
      })
      .then((response) =>{
      console.log(response.data);

      closeForm();
      alert("Deleted Successfully!")
   
      // toast.info(  "Deleted"+ " " + UserName +  "!", {
      //  position: "top-center",
      //  autoClose: 3200,
      //  hideProgressBar: false,
      //  closeOnClick: true,
      //  pauseOnHover: true,
      //  draggable: true,
      //  progress: undefined,
      //  className: 'toast-message'
      //  });
       setTimeout(() => {
         
         Getusers();
         GetAssignusers();
       }, 1000);
     
     
      })
   
         
  
     }




  function closeForm(){
    document.getElementById("modaldeleteForm").style.display ="None"
    document.getElementById('ParoassignForm').reset();
   }


   const LEFT_PAGE = "LEFT";
   const RIGHT_PAGE = "RIGHT";
   const range = (from, to, step = 1) => {
     let i = from;
     const range = [];
   
     while (i <= to) {
       range.push(i);
       i += step;
     }
   
     return range;
   };
   
   const [currentPage, setCurrentPage] = useState(1);
   
   let data = localStorage.getItem("Paro-assignusers")
   let transdata =  JSON.parse(data);
   console.log(transdata,'aaaa')
   let NUM_OF_RECORDS = transdata.length;
   let LIMIT = 5;
   
   const onPageChanged = useCallback(
   
     (event, page) => {
       event.preventDefault();
       setCurrentPage(page);
     },
     [setCurrentPage]
     
   );
   
   
   const currentData = transdata.slice(
     (currentPage - 1) * LIMIT,
     (currentPage - 1) * LIMIT + LIMIT
   );
   
   const Paginations = (props) => {
     const {
       totalRecords,
       pageLimit,
       pageNeighbours,
       onPageChanged,
       currentPage
     } = props;
     const [totalPages, setTotalPages] = useState(0);
     useEffect(() => {
       setTotalPages(Math.ceil(totalRecords / pageLimit));
     }, [setTotalPages]);
   
     const fetchPageNumbers = () => {
       const totalNumbers = pageNeighbours * 1 + 0;
     
       const totalBlocks = totalNumbers + 2;
      
       if (totalPages > totalBlocks) {
         const startPage = Math.max(2, currentPage - pageNeighbours);
         const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
   
         let pages = range(startPage, endPage);
   
         const hasLeftSpill = startPage > 2;
         const hasRightSpill = totalPages - endPage > 1;
         const spillOffset = totalNumbers - (pages.length + 1);
   
         switch (true) {
           case hasLeftSpill && !hasRightSpill: {
             const extraPages = range(startPage - spillOffset, startPage - 1);
             pages = [LEFT_PAGE, ...extraPages, ...pages];
             break;
           }
           case hasLeftSpill && hasRightSpill:
           default: {
             pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
             break;
           }
         }
         return [1, ...pages, totalPages];
       }
       return range(1, totalPages);
     };
   
   
     const pages = fetchPageNumbers() || [];
     return (
       <nav aria-label="Countries Pagination">
         <ul className="pagination" id='Paro-pag'>
           {pages.map((page, index) => {
             if (page === LEFT_PAGE)
               return (
                 <li key={index} className="Paropage-item">
                   <a
                     href="/"
                     className="page-link"
                     aria-label="Previous"
                     onClick={(e) => onPageChanged(e, pageNeighbours)}
                   >
                     <span aria-hidden="true">&laquo;</span>
                   </a>
                 </li>
               );
   
             if (page === RIGHT_PAGE)
               return (
                 <li key={index} className="Paropage-item">
                   <a
                     className="page-link"
                     href="/"
                     aria-label="Next"
                     onClick={(e) => onPageChanged(e, pageNeighbours*2+1 )}
                   >
                     <span aria-hidden="true">&raquo;</span>
                   </a>
                 </li>
               );
   
             return (
               <li
                 key={index}
                 className={`Paropage-item${currentPage === page ? " active" : ""}`}
               >
                 <a
                   className="page-link"
                   href="/"
                   onClick={(e) => onPageChanged(e, page)}
                 >
                   {page}
                 </a>
               </li>
             );
           })}
         </ul>
       </nav>
     );
   };
 
  return (
    
    /*----top bar----*/

    <>
    <div className='Paro-addmain'>

    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 

    <div className="Paro-addgrid-layout">
    <div className="Paro-addmain-top">
        <div className='Paro-addmain-back'>
           <Link to='/Paropakari '><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Assign</span>
 

     </div>
 </div>

 
 <form id="ParopassingForm">
 <div className='Paro-Assign-table'>
<div class="ParoAssign-table-responsive">
 
 <table class="Assign-Table-paro">
  <thead>
    <tr>
     
      <th>Username</th>

      <th>Assign</th>
      <th>Action</th>
      </tr>
      </thead>
      <tbody>
<tr>
      <td style={{whiteSpace:"nowrap"}}> <select className='Paro-Assign-select' id="Parouserid">
  
  
      {allusers1.map((e)=>{
      return<option  className='Paro-content' value={e.id}>{e.userName}</option>})}<br></br>
 
</select>
</td >
    
  <td id="Paroassignselect" style={{whiteSpace:"nowrap",width:"300px"}}>
    <div><Select  
       
       className="dropdown"
   options={optionList}
   id="CorpAselect"
   placeholder="Select Section"
   value={selectedOptions}
   onChange={handleSelect}
   isSearchable={true}
   isMulti
   isClearable
 /></div>
 </td>
  
 
     
  <td className='text-center' >
       
<button className='Paro-Assign-button' type="submit" onClick={AssignSection}> ASSIGN </button>
</td>
</tr>
      


 </tbody>
</table>

</div>
</div>

</form>


{/*  section display table */}


<div className='Paro-AssignMain-table' id='Paro-AssignTbl'>
<div class="ParoAssignMain-table-responsive">


  {
  !paginatedPosts ? ("No data found"):(<table className="Assign-Table-paro">
  <thead>
    <tr>
     
      <th>Username</th>
      <th>Section</th>
      <th>Action</th>
      </tr>
  </thead>
  <tbody>


 {/* mapping to assign */}

 {currentData.map((e) => {
      return<tr>
        <td>{e.userName}</td>
        <td >
        {e.section}
      </td>
      <td>

      <span class="paroAssign-action_btn">
      <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="ParoDelete-icon"></i></span> 
      {/* {e.active==0 ?<span className='ParoAssign-buttonA'>Active</span>: */}
       {/* <span className='ParoAssign-buttonB'>InActive</span>} */}
              
            </span>
      </td>
      </tr>
    })}

    
 </tbody>
</table>
  )}


<br></br>
{transdata.length<=5? null:<div>
{

!paginatedPosts ? (""):(

<Paginations



totalRecords={NUM_OF_RECORDS}

pageLimit={LIMIT}

pageNeighbours={2}

onPageChanged={onPageChanged}

currentPage={currentPage}

/>

)}
</div>}

  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> */}

</div>
</div>

{/* DeletePopup */}

{EditParo.map((e)=>{
  return<div className="Paropop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document" id="ParocenterDelform">
   <div className="modal-content">
   <div className="modal-header text-center">
     <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
     <button type="button" className="close" onClick={closeForm}>
       <span aria-hidden="true">&times;</span>
     </button>
   </div>

<form id='ParoassignForm'>

  <div className="modal-body mx-3">

       <div className="md-form mb-5">
           <div className='text-center'>
         <h5 id="Parodelformsize"><img src={Index} id="causeimg"></img><br></br>Are you sure want to delete?<span>{e.userName}</span> ? </h5>
         </div>
       </div>

  </div>

     <div className="modal-footer d-flex justify-content-center">
       <button className="Paro-delete-button" type='submit' onClick={()=>DeleteStatus(e.id,e.userName)}>Delete</button>
       <button className="Paro-delete-button" onClick={closeForm} type='submit'>Cancel</button>
     </div>

     </form>

     </div> 
   </div>
 </div>})}


</div>

 </>
 
  )
}

export default ParoassignMain